import { api } from './api';
import { Filter, FilterOption } from 'app/components/filters/types';
import { ActionDispatching } from 'app/types-shared';
import { errorSafe } from 'app/infrastructure/redux/index';
import * as actions from './action-types';
import * as actionTypes from 'app/infrastructure/simple-form/action-types';
import { STATE } from 'app/constants';
import { valuesSelector } from 'app/infrastructure/simple-form/selectors';
import { filterDomainIds } from 'app/area/filters/constants';
import { getSelectedOptionsIds } from 'app/area/filters/filters-mapping';
import { FilterOptionType } from 'app/area/filters/types';
import { selectFilterInstance } from 'app/area/filters/selectors';

export const actionCreators = (instanceKey: string) => ({
  updateFilters: (filters: Filter[]): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new actions.UpdateFilters(instanceKey, filters));
    }),

  loadFilters: (reportType?: number, reportId?: number): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {

      dispatch(new actions.RequestFilterDomains(instanceKey));

      const filterDomains = await api.loadFilters(reportType, reportId);
      
      const { filterDomain, reportTypeDescription } = filterDomains;
      const usePredefDate = filterDomains.usePredefDate;
      
      dispatch(new actions.ReceiveFilterDomains(instanceKey, filterDomain, { reportTypeDescription, usePredefDate }));
    }),

  loadAdvancedSearchTypes: (): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {

      const advancedSearchTypes = await api.loadAdvancedSearchTypes();

      dispatch(new actions.ReceiveAdvancedSearchTypes(instanceKey, advancedSearchTypes));
    }),

  loadAdvancedSearchFields: (query?: string): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {

      const filtersState = selectFilterInstance(instanceKey)(getState()) as any;

      const { simpleForm } = filtersState;
      const editingValues = valuesSelector(simpleForm);
      const optionsIds = getSelectedOptionsIds(editingValues, filterDomainIds.caseType);

      const advancedSearchFields = query ? await api.loadAdvancedSearchFieldsSearch(optionsIds, query)
        : await api.loadAdvancedSearchFields(optionsIds);

      dispatch(new actions.ReceiveAdvancedSearchOptions(instanceKey, advancedSearchFields));
    }),

  setFilterOpenState: (id: string, value: boolean): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new actions.SetFilterOpenState(instanceKey, id, value));
    }),

  setFilterOption: (option: FilterOption, type: FilterOptionType): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new actions.SetFilterOption(instanceKey, option, type));
    }),

  clearFilterOptions: (id: string): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new actions.ClearFilterOptions(instanceKey, id));
    }),

  clearAllFilterOptions: (): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new actions.ClearAllFilterOptions(instanceKey));
    }),

  clearValues: (ids: string[]): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      ids.forEach(id => dispatch(new actionTypes.ClearValueInStore([STATE.filters, 'instances', instanceKey], id)));
    }),

  clearAll: (): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new actions.ClearAll(instanceKey));
    })
});
